
const partial = (fn, arg1) => (...moreArgs) => fn(arg1, ...moreArgs)

export default partial
